import { Button, Icon, LinearProgress, Typography } from '@material-ui/core';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { Notifications } from '@material-ui/icons';
// @material-ui/icons
import { Assignment, Chat, People, PlaylistAddCheck } from '@material-ui/icons';

import dashboardStyle from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import {
  GetUserId,
  GetUserToken,
  Logout,
  GetUserKey
} from 'helpers/UserHelper';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import PropTypes from 'prop-types';
//Data
import { dashboardQuery } from 'queries/dashboardQuery';
import React from 'react';
import { graphql, Query, compose } from 'react-apollo';
import { connect } from 'react-redux';
//import { Carousel } from "react-responsive-carousel";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Redirect } from 'react-router';
import gql from '../../../node_modules/graphql-tag';
import Birthdays from './components/Birthdays.jsx';
import NewsList from './components/NewsList.jsx';
import './Dashboard.css';
import { ClientByBirthday } from './queries/clientBirthdays';
import { SendBirthdayWishes } from './mutations/SendEmail';
//import { Paper } from "@material-ui/core"

const newsQuery = gql`
  {
    NewsRss {
      feed
    }
  }
`;

// const productNewsData = [
//   {
//     imageUrl: "https://economictimes.indiatimes.com/photo/61639321.cms"
//   },
//   {
//     imageUrl:
//       "https://yw553ftvhw1iqegz29fycoyw-wpengine.netdna-ssl.com/wp-content/uploads/2017/10/Insurance.jpg"
//   },
//   {
//     imageUrl:
//       "http://www.thecheaperinsurance.com/wp-content/uploads/2015/08/17121703798_63f339f34a_o.jpg"
//   }
// ];

var ps;

class Dashboard extends React.Component {
  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      if (this.refs.newsList) {
        ps.destroy();
      }
      /* 	if (this.refs.birthdays) {
				ps2.destroy();
			} */
    }
  }

  componentDidUpdate(e) {
    if (navigator.platform.indexOf('Win') > -1) {
      if (this.refs.newsList) {
        ps = new PerfectScrollbar(this.refs.newsList, {
          wheelSpeed: 0.5,
          wheelPropagation: true,
          minScrollbarLength: 20
        });
      }
      /* if (this.refs.birthdays) {
				ps2 = new PerfectScrollbar(this.refs.birthdays, {
					wheelSpeed: 0.5,
					wheelPropagation: true,
					minScrollbarLength: 20,
					suppressScrollX: true
				});
			} */
    }
  }

  updatePs = () => {
    if (ps) {
      ps.update();
    }
  };

  updatePs2 = () => {
    /* 	if (ps2) {
			ps2.update();
		} */
  };

  render() {
    const { classes } = this.props;

    if (this.props.data.loading) {
      return <LinearProgress />;
    }
    var { data } = this.props;
    if (
      data.error &&
      data.error.message &&
      data.error.message === 'GraphQL error: invalid token'
    ) {
      Logout();
      return <Redirect to='/app/portal/login' />;
    }
    console.log(data)
    var quotes = JSON.parse(data.Dashboard[0].quotes);
    var clients = JSON.parse(data.Dashboard[0].clients);
    var unreadMessages = JSON.parse(data.Dashboard[0].unreadMessages);
    var dueTodos = JSON.parse(data.Dashboard[0].dueTodos);

    return (
      <div>
        <GridContainer>
          {GetUserKey('userType') !== '6' ? (
            <React.Fragment>
              <GridItem xs={12} sm={12} md={6} lg={6} xl={3}>
                <Card>
                  <CardHeader color='danger' stats icon>
                    <CardIcon color='sqOrange' style={{ padding: '10px' }}>
                      <Chat />
                    </CardIcon>
                    <div style={{ float: 'left', marginLeft: '10px' }}>
                      <p className={classes.cardCategory}>Unread Messages</p>
                      <h3
                        className={classes.cardTitle}
                        style={{ float: 'left' }}
                      >
                        {unreadMessages}
                      </h3>
                    </div>
                  </CardHeader>
                  <CardFooter stats>
                    <div
                      className={classes.stats}
                      style={{ margin: 'auto', textAlign: 'center' }}
                    >
                      <Button
                        variant='outlined'
                        className='outlinedButton'
                        style={{ float: 'left' }}
                        onClick={() =>
                          this.props.history.push('/app/clientmessagehistory')
                        }
                      >
                        Go to messages
                      </Button>
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6} lg={6} xl={3}>
                <Card>
                  <CardHeader color='success' stats icon>
                    <CardIcon color='sqPurple' style={{ padding: '10px' }}>
                      <Assignment />
                    </CardIcon>
                    <div style={{ float: 'left', marginLeft: '10px' }}>
                      <p className={classes.cardCategory}>My Quotes</p>
                      <h3
                        className={classes.cardTitle}
                        style={{ float: 'left' }}
                      >
                        {quotes.count}
                      </h3>
                    </div>
                    <div style={{ float: 'right' }}>
                      <p className={classes.cardCategory}>
                        This Week: <b>{quotes.lastWeek}</b>
                      </p>
                      <p className={classes.cardCategory}>
                        This Month: <b>{quotes.lastMonth}</b>
                      </p>
                    </div>
                  </CardHeader>
                  <CardFooter stats>
                    <div
                      className={classes.stats}
                      style={{ margin: 'auto', textAlign: 'center' }}
                    >
                      <Button
                        variant='outlined'
                        className='outlinedButton'
                        style={{ float: 'left' }}
                        onClick={() => this.props.history.push('/app/new')}
                      >
                        New Quote
                      </Button>
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6} lg={6} xl={3}>
                <Card>
                  <CardHeader color='warning' stats icon>
                    <CardIcon
                      color='sqPurpleSecond'
                      style={{ padding: '10px' }}
                    >
                      <People />
                    </CardIcon>
                    <div style={{ float: 'left', marginLeft: '10px' }}>
                      <p className={classes.cardCategory}>My Clients</p>
                      <h3
                        className={classes.cardTitle}
                        style={{ float: 'left' }}
                      >
                        {clients.count}
                      </h3>
                    </div>
                    <div style={{ float: 'right' }}>
                      <p className={classes.cardCategory}>
                        This Week: <b>{clients.lastWeek}</b>
                      </p>
                    </div>
                  </CardHeader>
                  <CardFooter stats>
                    <div
                      className={classes.stats}
                      style={{ margin: 'auto', textAlign: 'center' }}
                    >
                      <Button
                        variant='outlined'
                        className='outlinedButton'
                        style={{ float: 'left' }}
                        onClick={() =>
                          this.props.history.push('/app/ManageClients')
                        }
                      >
                        Manage Clients
                      </Button>
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </React.Fragment>
          ) : null}
          <GridItem xs={12} sm={12} md={6} lg={6} xl={3}>
            <Card>
              <CardHeader color='danger' stats icon>
                <CardIcon color='sqPurple' style={{ padding: '10px' }}>
                  <PlaylistAddCheck />
                </CardIcon>
                <div style={{ float: 'left', marginLeft: '10px' }}>
                  <p className={classes.cardCategory}>Due To Do Items</p>
                  <h3 className={classes.cardTitle} style={{ float: 'left' }}>
                    {dueTodos}
                  </h3>
                </div>
              </CardHeader>
              <CardFooter stats>
                <div
                  className={classes.stats}
                  style={{ margin: 'auto', textAlign: 'center' }}
                >
                  <Button
                    variant='outlined'
                    className='outlinedButton'
                    style={{ float: 'left',  }}
                    onClick={() => this.props.history.push('/app/usertodos')}
                  >
                    View To Do
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card style={{ height: '325px' }}>
              <CardHeader color='success' icon>
                <CardIcon color='sqLightBlue'>
                  <Notifications />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Latest News</h4>
              </CardHeader>
              <CardBody>
                <GridContainer justify='space-between'>
                  <GridItem xs={12} sm={12} md={12}>
                    <Card style={{ margin: '0px' }}>
                      <div
                        ref='newsList'
                        style={{
                          height: '250px',
                          position: 'relative',
                          overflow: 'scroll',
                          zIndex: '2'
                        }}
                        className='newsList'
                      >
                        <Query query={newsQuery} fetchPolicy='network-only'>
                          {({ loading, error, data }) => {
                            if (loading)
                              return (
                                <div>
                                  <LinearProgress />
                                </div>
                              );

                            if (error) {
                              return (
                                <Typography>
                                  Could not load news resources
                                </Typography>
                              );
                            }

                            let NewsDataString = data.NewsRss[0].feed;
                            let NewsDataObj = JSON.parse(NewsDataString);

                            return NewsDataString && NewsDataObj ? (
                              <NewsList
                                NewsDataObj={NewsDataObj}
                                updatePs={this.updatePs}
                              />
                            ) : null;
                          }}
                        </Query>
                      </div>
                    </Card>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card style={{ height: '325px' }}>
              <CardHeader color='success' icon>
                <CardIcon color='sqPurpleSecond'>
                  <Icon>cake</Icon>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Birthdays</h4>
              </CardHeader>
              <CardBody>
                <Card>
                  <div
                    /* ref="birthdays" */
                    style={{
                      height: '225px',
                      position: 'relative',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      zIndex: '2'
                    }}
                    className='birthdaysCard'
                  >
                    <Query
                      query={ClientByBirthday}
                      variables={{
                        brokerId: GetUserId(),
                        token: GetUserToken()
                      }}
                    >
                      {({ loading, error, data }) => {
                        if (loading)
                          return (
                            <div>
                              <LinearProgress />
                            </div>
                          );

                        if (error) {
                          console.log(error);
                          return (
                            <Typography>Could not load Birthdays</Typography>
                          );
                        }

                        return (
                          <Birthdays
                            data={data}
                            updatePs2={() => {}}
                            SendBirthdayWishes={this.props.SendBirthdayWishes}
                          />
                        );
                      }}
                    </Query>
                  </div>
                </Card>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

Dashboard = graphql(dashboardQuery, {
  options: () => ({ fetchPolicy: 'network-only' }),
  props: props => {
    return { ...props };
  }
})(Dashboard);

Dashboard = connect(state => ({
  brokerId: GetUserId(),
  token: GetUserToken()
}))(Dashboard);

Dashboard = compose(
  graphql(SendBirthdayWishes, { name: 'SendBirthdayWishes' })
)(Dashboard);

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx